import { render, staticRenderFns } from "./TextMange.vue?vue&type=template&id=f3c40ce2&scoped=true"
import script from "./TextMange.vue?vue&type=script&lang=js"
export * from "./TextMange.vue?vue&type=script&lang=js"
import style0 from "./TextMange.vue?vue&type=style&index=0&id=f3c40ce2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c40ce2",
  null
  
)

export default component.exports